// @ts-check
import { Component } from '@verndale/core';
import { debounce } from 'lodash';

class GatedAlertBanner extends Component {
  setupDefaults() {
    this.dom = {
      $gate: this.el,
      $body: document.querySelector('body'),
      $teaser: document.querySelector('.security-teaser')
    };

    window.scrollTo(0, 0);

    if (this.dom.$teaser) {
      this.initialWidth = window.innerWidth;
      this.setGateOffset();
    } else {
      document.body.style.overflow = 'hidden';
    }
  }

  addListeners() {
    if (this.dom?.$teaser) {
      window.addEventListener('scroll', this.handleScroll.bind(this), {
        passive: false
      }); // modern desktop
      window.addEventListener('touchmove', this.handleScroll.bind(this), {
        passive: false
      }); // mobile
      window.addEventListener(
        'resize',
        debounce(this.handleResize.bind(this), 100)
      );
    }
  }

  setGateOffset() {
    if (this.dom?.$teaser) {
      this.dom.$teaser.style.setProperty(
        'padding-block-end',
        `${this.dom?.$gate?.clientHeight + 15}px`
      );
    }
  }

  isInViewport() {
    if (this.dom?.$teaser) {
      const rect = this.dom?.$teaser.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    return false;
  }

  handleResize() {
    if (this.initialWidth && this.initialWidth !== window.innerWidth) {
      this.initialWidth = window.innerWidth;
      this.setGateOffset();
      this.maxDistance = undefined;
      window.scrollTo(0, 0);
    }
  }

  handleScroll() {
    if (this.maxDistance && window.scrollY > this.maxDistance) {
      window.scrollTo(0, this.maxDistance);
    }

    if (this.isInViewport()) {
      if (!this.maxDistance) this.maxDistance = window.scrollY;
    }
  }
}

export default GatedAlertBanner;
